import { getNumerologyTopic } from 'schools/numerology/data/numerologySyllabus';
import {
  buildSchoolTopicKey,
  getSchoolLearnTopicLabel,
  isSchoolLearnTopicKey,
  navigateToSchoolLearnTopic,
  parseSchoolTopicKey,
} from 'shared/schoolLearn/schoolTopicEngagement';
import { getJyotishaTopicLabel, getJyotishaTopicLabelHi } from '../data/jyotishaTopicLabels';
import { SYLLABUS_TOPIC_IDS } from './studentProfileStorage';
import { navigateToJyotishaTopic } from './studentNavigation';

const JYOTISHA_TOPIC_SET = new Set(SYLLABUS_TOPIC_IDS);

/** @param {string | null | undefined} topicId */
export function isNumerologyTopicId(topicId) {
  if (!topicId) return false;
  const parsed = parseSchoolTopicKey(topicId);
  if (parsed?.school === 'numerology') {
    return Boolean(getNumerologyTopic(parsed.topicId));
  }
  return Boolean(getNumerologyTopic(topicId));
}

/** @param {string} topicId */
export function numerologyTopicStorageKey(topicId) {
  const parsed = parseSchoolTopicKey(topicId);
  if (parsed?.school === 'numerology') return topicId;
  if (getNumerologyTopic(topicId)) return buildSchoolTopicKey('numerology', topicId);
  return topicId;
}

/** @param {string | null | undefined} topicId */
export function isJyotishaTopicId(topicId) {
  return Boolean(topicId && JYOTISHA_TOPIC_SET.has(topicId));
}

/**
 * Open bookmark/highlight in the correct syllabus section.
 * @param {string} topicId
 * @param {(page: string) => void} onPageChange
 */
export function navigateToLearnerTopic(topicId, onPageChange) {
  if (!topicId) return;
  if (isSchoolLearnTopicKey(topicId)) {
    navigateToSchoolLearnTopic(topicId);
    return;
  }
  if (isNumerologyTopicId(topicId)) {
    navigateToSchoolLearnTopic(numerologyTopicStorageKey(topicId));
    return;
  }
  if (!onPageChange) return;
  navigateToJyotishaTopic(topicId, onPageChange);
}

/** @param {string} topicId @param {boolean} showEnglish */
export function getLearnerTopicLabel(topicId, showEnglish) {
  if (isSchoolLearnTopicKey(topicId)) {
    return getSchoolLearnTopicLabel(topicId, showEnglish);
  }
  if (isNumerologyTopicId(topicId)) {
    const parsed = parseSchoolTopicKey(topicId);
    const slug = parsed?.school === 'numerology' ? parsed.topicId : topicId;
    const meta = getNumerologyTopic(slug);
    if (!meta) return slug;
    return showEnglish ? meta.topic.title.en : meta.topic.title.hi;
  }
  return showEnglish ? getJyotishaTopicLabel(topicId) : getJyotishaTopicLabelHi(topicId);
}
